export class StringUtility {
  static addZero(input: string | number, length: number): string {
    const parsedInput = input + '';
    const diff = length - parsedInput.length;
    if (diff <= 0) {
      return parsedInput;
    }
    let result = '';
    for (let i = 0; i < diff; i++) {
      result += '0';
    }
    return (result += parsedInput);
  }

  static isString<T>(potentialString: T): boolean {
    return potentialString?.constructor?.name === 'String';
  }

  static trimIfString<T extends any>(value: T): any {
    if (!StringUtility.isString(value)) {
      return value;
    }
    return (value as string).trim();
  }
}
